import Extensions from '..';

const extensions = {
  ...Extensions,
};

export default extensions;
